import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import useUser from "../auth/useUser";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import WorkflowAPI from "../../api/WorkflowAPI";
import { getErrorMessage } from "../../../utils/GeneralUtils";

const useWorkflows = (
  disabled = false,
  filter: (arg: Record<string, any>) => boolean
) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);
  const { user } = useUser();

  const workflows = useQuery({
    queryKey: ["workflows", tenantID],
    queryFn: () =>
      WorkflowAPI.getAllWorkflows().then((data) => data.data.data.workflows),
    enabled: !disabled,
    staleTime: Infinity,
  });

  return {
    workflows: filter ? workflows.data?.filter(filter) : workflows.data,
    workflowsLoading: workflows.isLoading || !user || queriesEnabled === false,
    workflowsError: workflows.error ? getErrorMessage(workflows.error) : null,
  };
};

export default useWorkflows;
